/**
 * @file phoneNumber.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-30
 * @modified 2026-10-30
 * @description A contact's phone number as shown, and as a tel: link. Moved
 *              out of ContactModal unchanged (29 Oct 2026) so the rep phone's
 *              customer card (utils/repContactCard) can dial the same number
 *              the customer window shows.
 *
 * Xero keeps a number in three parts — country code, area code, number — and
 * people fill them in every which way ("UK" as a country code, the area code
 * typed into the number). The display keeps what was typed; the link keeps
 * only digits and a leading +.
 */

/** "tel:07803582620" from the three parts, or null with no number. */
export function phoneTelHref(number, countryCode, areaCode) {
  if (!number) return null;
  const parts = [countryCode, areaCode, number].filter(Boolean).join('');
  const cleaned = parts.replace(/[^\d+]/g, '');
  return cleaned ? `tel:${cleaned}` : null;
}

/**
 * "(+44) 1884 820123" — the three parts as a person reads them; `none`
 * (default 'Not provided') when there is nothing at all.
 */
export function phoneDisplay(number, countryCode, areaCode, none = 'Not provided') {
  if (!number && !countryCode && !areaCode) return none;
  let display = '';
  if (countryCode) {
    const stripped = countryCode.replace(/[\s+]/g, '');
    if (/^\d{1,2}$/.test(stripped)) {
      display += `(+${stripped}) `;
    } else if (/^\d+$/.test(stripped)) {
      display += `${stripped} `;
    } else {
      display += `${countryCode} `;
    }
  }
  if (areaCode) {
    const stripped = areaCode.replace(/[\s]/g, '');
    if (/^\d+$/.test(stripped)) {
      display += `${stripped} `;
    } else {
      display += `${areaCode} `;
    }
  }
  display += number || '';
  return display.trim() || none;
}
